import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var ArrowUp = function ArrowUp(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9893 22.4922C12.8057 22.4922 13.3643 21.9229 13.3643 21.0742V8.49512L13.2783 6.16406L15.7275 8.94629L18.1768 11.374C18.4238 11.6318 18.7568 11.8037 19.165 11.8037C19.917 11.8037 20.4756 11.2451 20.4756 10.4609C20.4756 10.1064 20.3359 9.7627 20.0459 9.47266L13.0098 2.43652C12.752 2.15723 12.3652 2.00684 11.9893 2.00684C11.6133 2.00684 11.2373 2.15723 10.9688 2.43652L3.94336 9.47266C3.65332 9.7627 3.51367 10.1064 3.51367 10.4609C3.51367 11.2451 4.07227 11.8037 4.82422 11.8037C5.23242 11.8037 5.55469 11.6318 5.8125 11.374L8.25098 8.94629L10.7109 6.16406L10.6143 8.49512V21.0742C10.6143 21.9229 11.1729 22.4922 11.9893 22.4922Z"
  })));
};

ArrowUp.displayName = 'ArrowUp';
export default ArrowUp;